// extracted by mini-css-extract-plugin
export default {"item":"CaseCountList_item__gmvsU"};